import { render, staticRenderFns } from "./MarkdownSegmentEditor.vue?vue&type=template&id=5b5ec6f0&"
import script from "./MarkdownSegmentEditor.vue?vue&type=script&lang=js&"
export * from "./MarkdownSegmentEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports